import React from 'react';
import { CalendarIcon, TrendingUpIcon, UsersIcon, MessageSquareIcon, SparklesIcon } from 'lucide-react';
// Group-specific widget content
const WIDGET_CONTENT: Record<string, any> = {
  '1': {
    topics: ['Organizzazione frigo e dispensa', 'Riuso e riparazione', 'Spesa sfusa e refill'],
    activeMembers: [{
      name: 'Laura Bianchi',
      avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      posts: 12
    }, {
      name: 'Marco Rossi',
      avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      posts: 8
    }, {
      name: 'Giulia Neri',
      avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      posts: 6
    }],
    events: [{
      name: 'Swap Party di quartiere',
      location: 'Milano',
      time: 'Sab 18:00'
    }, {
      name: 'Workshop compostaggio',
      location: 'Bologna',
      time: 'Dom 10:30'
    }]
  },
  '2': {
    topics: ['Percorsi casa-lavoro', 'Sicurezza e manutenzione', 'Trasporto pubblico + bici'],
    activeMembers: [{
      name: 'Alessandro Verdi',
      avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      posts: 10
    }, {
      name: 'Chiara Riva',
      avatar: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      posts: 7
    }, {
      name: 'Edoardo G.',
      avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      posts: 5
    }],
    events: [{
      name: 'Bike to Work Day',
      location: 'Torino',
      time: 'Ven 8:00'
    }, {
      name: 'Check-up bici gratuito',
      location: 'Firenze',
      time: 'Sab 15:00'
    }]
  },
  '3': {
    topics: ['Stagionalità', 'Anti-spreco in cucina', 'Etichette e ingredienti'],
    activeMembers: [{
      name: 'Sara Conti',
      avatar: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      posts: 15
    }, {
      name: 'Luca Ferri',
      avatar: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      posts: 9
    }, {
      name: 'Elena P.',
      avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
      posts: 7
    }],
    events: [{
      name: 'Cooking class anti-spreco',
      location: 'Roma',
      time: 'Sab 11:00'
    }, {
      name: 'Mercato contadino: tour guidato',
      location: 'Milano',
      time: 'Dom 9:30'
    }]
  }
};
const AlgaWeeklySummaryWidget: React.FC<{
  groupId?: string;
}> = ({
  groupId
}) => {
  const content = WIDGET_CONTENT[groupId || '1'] || WIDGET_CONTENT['1'];
  return <div className="space-y-4" data-id="element-1673">
      {/* Weekly Summary Widget */}
      <div className="bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm" data-id="element-1674">
        <div className="p-4 border-b border-gray-200 flex items-center bg-gradient-to-r from-green-50 to-emerald-50" data-id="element-1675">
          <div className="w-8 h-8 rounded-full bg-green-600 flex items-center justify-center mr-3 shadow-sm" data-id="element-1676">
            <SparklesIcon size={16} className="text-white" strokeWidth={2} data-id="element-1677" />
          </div>
          <div data-id="element-1678">
            <h2 className="text-base font-semibold text-gray-900" data-id="element-1679">
              Sintesi Settimanale
            </h2>
            <p className="text-xs text-gray-600 font-normal" data-id="element-1680">
              Powered by Greenback AI
            </p>
          </div>
        </div>
        <div className="p-4 space-y-4" data-id="element-1681">
          {/* Main Topics */}
          <div className="p-3 bg-gray-50 rounded-lg border border-gray-100" data-id="element-1682">
            <h3 className="font-medium text-gray-900 text-sm mb-2 flex items-center" data-id="element-1683">
              <TrendingUpIcon size={16} className="mr-2 text-green-600" strokeWidth={1.5} data-id="element-1684" />
              Argomenti principali
            </h3>
            <ul className="text-sm text-gray-700 space-y-1.5 font-normal" data-id="element-1685">
              {content.topics.map((topic: string, index: number) => <li key={index} className="flex items-start" data-id="element-1686">
                  <span className="text-green-600 mr-2" data-id="element-1687">•</span>
                  <span data-id="element-1688">{topic}</span>
                </li>)}
            </ul>
          </div>

          {/* Active Members */}
          <div className="p-3 bg-gray-50 rounded-lg border border-gray-100" data-id="element-1689">
            <h3 className="font-medium text-gray-900 text-sm mb-3 flex items-center" data-id="element-1690">
              <UsersIcon size={16} className="mr-2 text-green-600" strokeWidth={1.5} data-id="element-1691" />
              Membri più attivi
            </h3>
            <div className="space-y-2" data-id="element-1692">
              {content.activeMembers.map((member: any, index: number) => <div key={index} className="flex items-center" data-id="element-1693">
                  <div className="w-6 h-6 rounded-full overflow-hidden mr-2 flex-shrink-0" data-id="element-1694">
                    <img src={member.avatar} alt={member.name} className="w-full h-full object-cover" data-id="element-1695" />
                  </div>
                  <span className="text-sm text-gray-700 font-normal flex-1" data-id="element-1696">
                    {member.name}
                  </span>
                  <span className="text-xs text-gray-500 font-normal" data-id="element-1697">
                    {member.posts} post
                  </span>
                </div>)}
            </div>
          </div>

          {/* Recent Events */}
          <div className="p-3 bg-gray-50 rounded-lg border border-gray-100" data-id="element-1698">
            <h3 className="font-medium text-gray-900 text-sm mb-3 flex items-center" data-id="element-1699">
              <CalendarIcon size={16} className="mr-2 text-green-600" strokeWidth={1.5} data-id="element-1700" />
              Eventi recenti
            </h3>
            <div className="space-y-3" data-id="element-1701">
              {content.events.map((event: any, index: number) => <div key={index} className="text-sm" data-id="element-1702">
                  <p className="font-medium text-gray-900" data-id="element-1703">{event.name}</p>
                  <p className="text-xs text-gray-600 font-normal mt-0.5" data-id="element-1704">
                    {event.location} • {event.time}
                  </p>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default AlgaWeeklySummaryWidget;